import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { BLOCKS, INLINES, MARKS } from "@contentful/rich-text-types"
import React, {useEffect} from "react"
import GuideTo from "../../../shared/components/molecules/guided-to/guideTo"
import { formatDate } from "../../../shared/state/utils/utilities-date"
import Button from "../../../shared/components/atoms/Button/Button"
import Comments from "../../../shared/components/organisms/comments/comments"
import useSessionState from "../../../shared/hooks/useSessionState"
import Banner from "../../../shared/components/molecules/banner/banner"
import useLocalEventLikes from "../../../shared/hooks/useLocalEventLikes"
import GuidelineCard from "../../../shared/components/molecules/guideline-card/guideline-card"
import { pushDataLayerEvent } from '../../../shared/utils/metricManagementUtil'
import { dataLayerUserInfo } from '../../../shared/utils/userInfo'
import "./section-article.scss"

const capitalize = text => {
    return text.charAt(0).toUpperCase() + text.slice(1)
}

const SectionArticle = props => {
    const {
        descripcionArticuloCompleta,
        fechaDePublicacion,
        imagenArticuloCompleta,
        categoria,
        tituloEnHeader,
        tienePauta,
        pauta,
    } = props.article

    let tag = categoria[0].nombreDeEtiqueta?.toLowerCase() || ''
    let options = {
        renderMark: {
            [MARKS.BOLD]: text => <b>{text}</b>,
            [MARKS.CODE]: link => (
                <span
                    className="f-iframe-content"
                    dangerouslySetInnerHTML={{ __html: link }}
                ></span>
            ),
        },
        renderNode: {
            [BLOCKS.HEADING_1]: (node, next) => <h1>{next}</h1>,
            [BLOCKS.HEADING_6]: (node, next) => (
                <div className="f-article-pattern">
                    <p className="f-p">{next}</p>
                    <Button
                        text="INSCRÍBETE"
                        type="button"
                        classname="f-button f-button--clear-transparent"
                        onClickAction={() => {
                            !isLoggedUser &&
                                document
                                    .getElementById("leafletCard")
                                    .scrollIntoView({ behavior: "smooth" })
                        }}
                    />
                </div>
            ),
            [BLOCKS.EMBEDDED_ASSET]: (node, next) => (
                <img
                    src={node.data.target.fields.file["es-CO"].url}
                    alt={node.data.target.fields.description["es-CO"]}
                />
            ),
            [INLINES.HYPERLINK]: (node, next) => {
                return node.data.uri.includes('https://jwp.io') ||
				node.data.uri.includes('youtube') ||
				node.data.uri.includes('youtu.be') ? (
				<iframe
					className='f-article-video'
					frameBorder='0'
					sandbox='allow-popups allow-same-origin allow-scripts'
					scrolling='no'
					src={
						node.data.uri.includes('youtube')
							? node.data.uri.replace('watch?v=', 'embed/')
							: node.data.uri.includes('youtu.be')
							? node.data.uri.replace('.be/', 'be.com/embed/')
							: node.data.uri
					}
					allowFullScreen
				/>
			) : (<a href={node.data.uri} target="_blank" onClick={()=>{dataLayerLink(node.data.uri)}}>
                    {next}
                </a>
            )
            },
        },
    }

    const { isLoggedUser } = useSessionState()
    const { likesInfo, toogleLike } = useLocalEventLikes({
        eventId: 0,
        conferenceCmsId: props.article.contentful_id,
    })

    const createDate = new Date(fechaDePublicacion)

    const userInfo=dataLayerUserInfo()
    const dataLayerLink =(to)=>{
        let loc=''
		if (typeof window !== 'undefined') {
			loc= window.location.href
		}
        pushDataLayerEvent({event: 'Interacciones - Enlaces',
		category: 'links',
		action: 'click',
		label: to,
		location: loc,
		user_data: userInfo.user_data? userInfo.user_data: '',
		log_status: userInfo.log_status,})
	}
    const dataLaterArticle = (titulo, subCat) => {
		const sub= subCat!==''? subCat: 'ninguno'
		let location=''
		if (typeof window !== 'undefined') {
			location= window.location.href
		}
        if(sub.toUpperCase()=='INCONTINENCIA'){
            pushDataLayerEvent({event: 'Interacciones - Incontinencia',
            category: 'vista sección',
            action: 'view',
            label: titulo,
            article_name: titulo,
            location: location,
            article_type:'Artículo',
            user_data: userInfo.user_data? userInfo.user_data: '',
            log_status: userInfo.log_status,})
        }else{
            pushDataLayerEvent({event: 'Article View',
            category: 'academia tena',
            action: 'view',
            label: titulo,
            article_name: titulo,
            sub_category: sub,
            location: location,
            article_type:'Artículo',
            user_data: userInfo.user_data? userInfo.user_data: '',
            log_status: userInfo.log_status,})
        }
	}

    let initialTime = ''
    useEffect(() => {
        dataLaterArticle(props.article.titulo,tag)
        if (typeof window !== 'undefined'){
            initialTime = window.performance.now()
            window.addEventListener('beforeunload', () => {dataLayerDuracionArticulo(initialTime, tag, props.article.titulo)})
            window.addEventListener('scroll', () => {handleScroll(tag, props.article.titulo)})
        }
    }, [])

	const dataLayerDuracionArticulo = (initialTime, subCat, articleName) => {
        let endTime = ''
        let location=''
        if (typeof window !== 'undefined') {
            location= window.location.href
            endTime = (window.performance.now() - initialTime)/1000
        }
        if(endTime>60 && scrollFlag50===false){
            pushDataLayerEvent({
                event: 'content_consumption'
            })
        }

        if(subCat.toUpperCase() === "INCONTINENCIA"){
            pushDataLayerEvent({event: 'Interacciones - Incontinencia',
            category: 'duración_sección',
            action: 'time',
            duration_time: `${endTime}s`,
            article_name: articleName,
            location: location,
            article_type: 'Artículo',
            user_data: userInfo.user_data? userInfo.user_data: '',
            log_status: userInfo.log_status,})
        } else {
            const subCatAux = subCat !== '' ? subCat : 'niguno' 
            pushDataLayerEvent({event: 'Interacciones - Articulos',
            category: 'duración artículo',
            action: 'time',
            duration_time: `${endTime}s`,
            article_name: articleName,
            sub_category: subCatAux, 
            location: location,
            article_type: 'Artículo',
            user_data: userInfo.user_data? userInfo.user_data: '',
            log_status: userInfo.log_status,})
        }
	}

    const dataLayerScrollArticulo = (scroll, subCat, articleName) => {
        let location=''
        if (typeof window !== 'undefined') {
            location= window.location.href
        }
        if(subCat.toUpperCase() === "INCONTINENCIA"){
            pushDataLayerEvent({event: 'Interacciones - Incontinencia',
            category: 'profundidad_scroll',
            action: 'scroll',
            scroll_tracking: scroll,
            article_name: articleName,
            location: location,
            article_type: 'Artículo',
            user_data: userInfo.user_data? userInfo.user_data: '',
            log_status: userInfo.log_status,})
        } else {
            const subCatAux = subCat !== '' ? subCat : 'niguno' 
            pushDataLayerEvent({event: 'Interacciones - Articulos',
            category: 'scroll_artículo',
            action: 'scroll',
            scroll_tracking: scroll,
            article_name: articleName,
            sub_category: subCatAux, 
            location: location,
            article_type: 'Artículo',
            user_data: userInfo.user_data? userInfo.user_data: '',
            log_status: userInfo.log_status,})
        }
    }

    let scrollFlag25 = true
    let scrollFlag50 = true
    let scrollFlag75 = true
    let scrollFlag100 = true
    const handleScroll = (subCat, articleName) => {
        const scrollPercentage = (document.documentElement.scrollTop / (document.documentElement.scrollHeight-document.documentElement.clientHeight))*100
        if(scrollFlag25 && scrollPercentage >= 25){
            dataLayerScrollArticulo('25', subCat, articleName)
            scrollFlag25 = false
        }
        if(scrollFlag50 && scrollPercentage >= 50){
            dataLayerScrollArticulo('50', subCat, articleName)
            scrollFlag50 = false
        }
        if(scrollFlag75 && scrollPercentage >= 75){
            dataLayerScrollArticulo('75', subCat, articleName)
            scrollFlag75 = false
        }
        if(scrollFlag100 && scrollPercentage >= 100){
            dataLayerScrollArticulo('100', subCat, articleName)
            scrollFlag100 = false
        }
    }

    return (
        <>
            <div className="f-article-wrapper f-article-wrapper--fullwidth">
                <div className="f-article f-article--fullwidth">
                    <Banner
                        likes={{ info: likesInfo, toogle: toogleLike }}
                        info={{
                            image: imagenArticuloCompleta,
                            tag: capitalize(tag),
                            title: props.article.titulo,
                            date: formatDate(createDate, true),
                            isMobile: props.ismobile,
                            titleInHeader: tituloEnHeader,
                        }}
                    />

                    <div className="f-contentsection">
                        {tienePauta && pauta && (
                            <GuidelineCard guideline={pauta} />
                        )}

                        <div
                            className={`f-contentsection__content ${
                                tienePauta && pauta
                                    ? "f-contentsection__content--guide-card"
                                    : ""
                            }`}
                        >
                            {descripcionArticuloCompleta &&
                                documentToReactComponents(
                                    descripcionArticuloCompleta.json,
                                    options
                                )}
                        </div>

                        {props.article.dirigidoA && (
                            <GuideTo
                                isCentered={false}
                                guideInfo={props.article.dirigidoA}
                            />
                        )}
                    </div>
                </div>
            </div>
            {props.products}
            <Comments
                buttonProspect="Finalizar y comentar"
                prospectRegister={true}
                talkInfo={{ conferenciaId: props.article.contentful_id }}
                requireLogin={true}
            />
        </>
    )
}
export default SectionArticle
